import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
// import LoginLayout, { Input } from "../../components/LoginLayout";
import { API_URL } from "../../apis/apiurl";
import { useAppContext } from "../../context/appContext";
import LoginLayout, { Input } from "../../components/loginLayout";
import { PROFILE_USERTYPE, TOKEN_KEY } from "../../config/variable";
// import LoginLayout from "../../components/loginLayout";

const Login = () => {
  const { setPopupMessage } = useAppContext();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();

  const loginUser = async ({ email, password }) => {
    const response = await fetch(`${API_URL}/graphql`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        query: `
          mutation LoginUser {
            loginUser(email: "${email}", password: "${password}") {
              email
              token
              role
            }
          }
        `,
      }),
    });
    const data = await response.json();
    if (data.errors) {
      const error = JSON.parse(data.errors[0].message);
      setPopupMessage(error?.message);
      throw new Error(error?.message);
    }
    return data.data.loginUser;
  };

  const { mutate, data, isPending, error } = useMutation({
    mutationFn: loginUser,
  });

  // console.log("23123123123", data);
  useEffect(() => {
    if (data?.role === PROFILE_USERTYPE) {
      const storage = rememberMe ? localStorage : sessionStorage;
      storage.setItem(TOKEN_KEY, JSON.stringify(data));
      navigate("/report");
      window.location.reload();
    } else if (data) {
      setPopupMessage("Wrong credentials");
    }
  }, [data, rememberMe, navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (email && password) mutate({ email, password });
  };

  return (
    <LoginLayout
      error={error?.message}
      loading={isPending}
      onSubmit={handleSubmit}
      title="Login"
      subtitle="Glad you're back!"
      actionText="Log In"
      links={{
        register: "register/?role=client",
        forgot: "/resetpassword",
      }}
    >
      <Input
        type="email"
        placeholder="E-mail"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <Input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />
      <div className="flex items-center text-gray-700">
        <input
          type="checkbox"
          id="remember-me"
          className="mr-2"
          checked={rememberMe}
          onChange={(e) => setRememberMe(e.target.checked)}
        />
        <label htmlFor="remember-me" className="text-sm">
          Remember me
        </label>
      </div>
    </LoginLayout>
  );
};

export default Login;
